import React from 'react';
import { createRoot } from 'react-dom/client';
import { BillingConsoleApp } from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BillingConsoleApp />
  </React.StrictMode>,
);
